import { _, helpers, React, ts, ui } from '_core';

import { transform } from './helpers';
import { Params } from './types';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  portfolios: string;
  fullScreen: boolean;
  params: Params;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  title: string;
  hasBenchmark: boolean;
};

const Chart = ({ id, readOnly, loadWidgetData, portfolios, fullScreen, params, title, hasBenchmark }: ChartProps) => {
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: portfolios,
        },
      });
      if (response) {
        const resp = response.data.map((el) => ({
          date: el.end_date,
          ..._.omit(el, ['start_date', 'end_date']),
        }));
        setData(transform(resp, params.isBasket, params.with_benchmark ?? hasBenchmark));
      }
    } catch (err) {
      setError(JSON.stringify(err));
    }
  };
  React.useEffect(() => {
    if (portfolios) loadData();
    return () => setData(null);
  }, [portfolios]);

  return (
    <ui.LineChart
      id={id}
      data={data}
      fullScreen={fullScreen}
      readOnly={readOnly}
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      exportTitle={title}
      numberFormat="#.##%"
      showEndValueLabel
    />
  );
};

export default Chart;
